import Axios from "axios";
import { getResponseData, getResponseDataWithStatusOld } from "../../utils/helper";
import { getBaseUrl, palateDiscoveryLinks } from "../../utils/links";

const CancelToken = Axios.CancelToken;

export let getPalateDiscoveryTestCancelToken = undefined;
export const getPalateDiscoveryTest = (token, id) => {
    if (getPalateDiscoveryTestCancelToken) getPalateDiscoveryTestCancelToken();
    let url = `${getBaseUrl()}${palateDiscoveryLinks.test(id)}`,
        options = {
            url,
            headers: {
                Authorization: `Bearer ${token}`,
            },
            cancelToken: new CancelToken((c) => (getPalateDiscoveryTestCancelToken = c)),
        };
    return Axios(options)
        .then((response) => {
            let successData = getResponseData(response);
            if (successData) {
                return successData;
            } else {
                throw response;
            }
        })
        .catch((err) => {
            throw err;
        });
};


export let getPalateDiscoveryPreviewCancelToken = undefined;
export const getPalateDiscoveryPreview = (token) => {
    if (getPalateDiscoveryPreviewCancelToken) getPalateDiscoveryPreviewCancelToken();
    let url = `${getBaseUrl()}${palateDiscoveryLinks.preview}`,
        options = {
            url,
            headers: {
                Authorization: `Bearer ${token}`,
            },
            cancelToken: new CancelToken((c) => (getPalateDiscoveryPreviewCancelToken = c)),
        };
    return Axios(options)
        .then((response) => {
            let successData = getResponseData(response);
            if (successData) {
                return successData;
            }  else {
                throw response;
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const submitPalateAnswers = (token, id, data) => {
    let url = `${getBaseUrl()}${palateDiscoveryLinks.submit(id)}`,
        options = {
            url,
            data,
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
    return Axios(options)
        .then((response) => {
            let successData = getResponseDataWithStatusOld(response);
            return successData;
        })
        .catch(() => getResponseDataWithStatusOld(null, true));
};

export let getPalateDiscoveryTestResultCancelToken = undefined;
export const getPalateDiscoveryTestResult = (token , profileId) => {
    if (getPalateDiscoveryTestResultCancelToken) getPalateDiscoveryTestResultCancelToken();
    let url = `${getBaseUrl()}${palateDiscoveryLinks.result(profileId)}`,
        options = {
            url,
            headers: {
                Authorization: `Bearer ${token}`,
            },
            cancelToken: new CancelToken((c) => (getPalateDiscoveryTestResultCancelToken = c)),
        };
    return Axios(options)
        .then((response) => {
            let successData = getResponseData(response);
            if(successData){
                return successData;
            } else {
                throw response
            }
        })
        .catch((err) => {
            throw err;
        });
};


export let getPalateDiscoveryTestReportCancelToken = undefined;
export const getPalateDiscoveryTestReport = (token , assignmentId) => {
    if (getPalateDiscoveryTestReportCancelToken) getPalateDiscoveryTestReportCancelToken();
    let url = `${getBaseUrl()}${palateDiscoveryLinks.report(assignmentId)}`,
        options = {
            url,
            headers: {
                Authorization: `Bearer ${token}`,
            },
            cancelToken: new CancelToken((c) => (getPalateDiscoveryTestReportCancelToken = c)),
        };
    return Axios(options)
        .then((response) => {
            let successData = getResponseData(response);
            if(successData){
                return successData;
            } else {
                throw response
            }
        })
        .catch((err) => {
            throw err;
        });
};


export let getPalateDiscoveryAnswersCancelToken = undefined;
export const getPalateDiscoveryAnswers = (token, id) => {
  if (getPalateDiscoveryAnswersCancelToken) getPalateDiscoveryAnswersCancelToken();
  let url = `${getBaseUrl()}${palateDiscoveryLinks.answers(id)}`,
    options = {
      url,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      cancelToken: new CancelToken((c) => (getPalateDiscoveryAnswersCancelToken = c)),
    };
  return Axios(options)
    .then((response) => {
      let successData = getResponseData(response);      
      return successData;
    })
    .catch(() => false);
};
